import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './price-updated.svg'


_pushScopeId("data-v-2d5e649c")
const _hoisted_1 = { class: "header flex items-center justify-between pl-[18px] pr-[12px] py-[14px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Confirm Swap", -1)
const _hoisted_3 = { class: "token-input flex justify-between p-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "fiat" }
const _hoisted_8 = { class: "flex w-full justify-center" }
const _hoisted_9 = { class: "arrow absolute" }
const _hoisted_10 = { class: "token-input mt-[1px] flex justify-between p-4 dark-back" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "ml-2" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "fiat" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "px-[12px] dark-back" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "break" })
], -1)
const _hoisted_16 = { class: "summary-card dark-back" }
const _hoisted_17 = {
  key: 0,
  class: "accept-update flex items-center justify-between p-[12px] dark-back"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "mr-[8px]"
  }),
  /*#__PURE__*/_createElementVNode("div", null, "Price updated")
], -1)
const _hoisted_19 = { class: "px-[12px] pb-[12px] dark-back" }
_popScopeId()

import { SubgraphPoolBase } from '@balancer-labs/sdk';
import { Pool } from '@balancer-labs/sor/dist/types';
import { formatUnits } from '@ethersproject/units';
import { mapValues } from 'lodash';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import TradeRoute from '@/components/cards/TradeCard/TradeRoute.vue';
import { TradeQuote } from '@/composables/trade/types';
import useRelayerApproval, {
  Relayer,
} from '@/composables/trade/useRelayerApproval';
import useTokenApproval from '@/composables/trade/useTokenApproval';
import { UseTrading } from '@/composables/trade/useTrading';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';
import useUserSettings from '@/composables/useUserSettings';
import { FiatCurrency } from '@/constants/currency';
import { bnum } from '@/lib/utils';
import { isStETH } from '@/lib/utils/balancer/lido';
import { getWrapAction, WrapType } from '@/lib/utils/balancer/wrapper';
import useWeb3 from '@/services/web3/useWeb3';
import X from './x.vue';
import CloseIcon from '@/components/_global/icons/CloseIcon.vue';
import ArrowDownSwap from './ArrowDownSwap.vue';
import TradePreviewModalGP from '@/components/modals/TradePreviewModalGP.vue';

type Props = {
  trading: UseTrading;
};
/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    trading: { type: null, required: true }
  } as unknown as undefined,
  emits: ['trade', 'close'],
  setup(__props: {
  trading: UseTrading;
}, { emit }) {

const props = __props
const PRICE_UPDATE_THRESHOLD = 0.02;


// COMPOSABLES
const { t } = useI18n();
const { fNum2, toFiat } = useNumbers();
const { tokens, approvalRequired } = useTokens();
const { blockNumber } = useWeb3();
const { slippage } = useUserSettings();
// state
const lastQuote = ref<TradeQuote | null>(
  props.trading.isWrapUnwrapTrade.value ? null : props.trading.getQuote()
);
const priceUpdated = ref(false);
const priceUpdateAccepted = ref(false);
// DATA
const showSummaryInFiat = ref(false);
// COMPUTED
const slippageRatePercent = computed(() =>
  fNum2(slippage.value, FNumFormats.percent)
);
const addressIn = computed(() => props.trading.tokenIn.value.address);
const tokenInFiatValue = computed(() =>
  fNum2(
    toFiat(
      props.trading.tokenInAmountInput.value,
      props.trading.tokenIn.value.address
    ),
    FNumFormats.fiat
  )
);
const tokenOutFiatValue = computed(() =>
  fNum2(
    toFiat(
      props.trading.tokenOutAmountInput.value,
      props.trading.tokenOut.value.address
    ),
    FNumFormats.fiat
  )
);
const showTradeRoute = computed(() => props.trading.isBalancerTrade.value);
const zeroFee = computed(() =>
  showSummaryInFiat.value ? fNum2('0', FNumFormats.fiat) : '0.0 ETH'
);
const summary = computed(() => {
  const summaryItems = {
    amountBeforeFees: '',
    tradeFees: '',
    totalWithoutSlippage: '',
    totalWithSlippage: '',
  };
  const exactIn = props.trading.exactIn.value;
  const tokenIn = props.trading.tokenIn.value;
  const tokenOut = props.trading.tokenOut.value;
  const tokenInAmountInput = props.trading.tokenInAmountInput.value;
  const tokenOutAmountInput = props.trading.tokenOutAmountInput.value;
  if (props.trading.isWrapUnwrapTrade.value) {
    summaryItems.amountBeforeFees = tokenOutAmountInput;
    summaryItems.tradeFees = '0';
    summaryItems.totalWithoutSlippage = tokenOutAmountInput;
    summaryItems.totalWithSlippage = tokenOutAmountInput;
  } else {
    const quote = props.trading.getQuote();
    if (exactIn) {
      summaryItems.amountBeforeFees = tokenOutAmountInput;
      summaryItems.tradeFees = formatUnits(
        quote.feeAmountOutToken,
        tokenOut.decimals
      );
      summaryItems.totalWithoutSlippage = bnum(summaryItems.amountBeforeFees)
        .minus(summaryItems.tradeFees)
        .toString();
      summaryItems.totalWithSlippage = formatUnits(
        quote.minimumOutAmount,
        tokenOut.decimals
      );
    } else {
      summaryItems.amountBeforeFees = tokenInAmountInput;
      summaryItems.tradeFees = formatUnits(
        quote.feeAmountInToken,
        tokenIn.decimals
      );
      summaryItems.totalWithoutSlippage = bnum(summaryItems.amountBeforeFees)
        .plus(summaryItems.tradeFees)
        .toString();
      summaryItems.totalWithSlippage = formatUnits(
        quote.maximumInAmount,
        tokenIn.decimals
      );
    }
  }
  if (showSummaryInFiat.value) {
    return mapValues(
      summaryItems,
      itemValue =>
        `${fNum2(
          toFiat(itemValue, exactIn ? tokenOut.address : tokenIn.address),
          FNumFormats.fiat
        )}`
    );
  } else {
    return mapValues(
      summaryItems,
      itemValue =>
        `${fNum2(itemValue, FNumFormats.token)} ${
          exactIn || props.trading.isWrapUnwrapTrade.value
            ? tokenOut.symbol
            : tokenIn.symbol
        }`
    );
  }
});
const labels = computed(() => {
  if (props.trading.isWrap.value) {
    return {
      modalTitle: t('previewWrap', [props.trading.tokenIn.value.symbol]),
      confirmTrade: t('confirmWrap', [props.trading.tokenIn.value.symbol]),
      tradeSummary: {
        title: t('tradeSummary.wrap.title'),
        tradeFees: t('tradeSummary.wrap.tradeFees'),
        totalBeforeFees: t('tradeSummary.wrap.totalBeforeFees'),
        totalAfterFees: t('tradeSummary.wrap.totalAfterFees'),
        totalWithSlippage: t('tradeSummary.wrap.totalWithSlippage', [
          props.trading.tokenIn.value.symbol,
        ]),
      },
    };
  } else if (props.trading.isUnwrap.value) {
    return {
      modalTitle: t('previewUnwrap', [props.trading.tokenOut.value.symbol]),
      confirmTrade: t('confirmUnwrap', [props.trading.tokenOut.value.symbol]),
      tradeSummary: {
        title: t('tradeSummary.unwrap.title'),
        tradeFees: t('tradeSummary.unwrap.tradeFees'),
        totalBeforeFees: t('tradeSummary.unwrap.totalBeforeFees'),
        totalAfterFees: t('tradeSummary.unwrap.totalAfterFees'),
        totalWithSlippage: t('tradeSummary.unwrap.totalWithSlippage', [
          props.trading.tokenOut.value.symbol,
        ]),
      },
    };
  } else if (props.trading.exactIn.value) {
    return {
      modalTitle: t('previewTrade'),
      confirmTrade: t('confirmTrade'),
      tradeSummary: {
        title: t('tradeSummary.exactIn.title', [
          props.trading.tokenIn.value.symbol,
        ]),
        tradeFees: t('tradeSummary.exactIn.tradeFees'),
        totalBeforeFees: t('tradeSummary.exactIn.totalBeforeFees'),
        totalAfterFees: t('tradeSummary.exactIn.totalAfterFees'),
        totalWithSlippage: t('tradeSummary.exactIn.totalWithSlippage', [
          slippageRatePercent.value,
        ]),
      },
    };
  }
  // exact out
  return {
    modalTitle: t('previewTrade'),
    confirmTrade: t('confirmTrade'),
    tradeSummary: {
      title: t('tradeSummary.exactOut.title', [
        props.trading.tokenOut.value.symbol,
      ]),
      tradeFees: t('tradeSummary.exactOut.tradeFees'),
      totalBeforeFees: t('tradeSummary.exactOut.totalBeforeFees'),
      totalAfterFees: t('tradeSummary.exactOut.totalAfterFees'),
      totalWithSlippage: t('tradeSummary.exactOut.totalWithSlippage', [
        slippageRatePercent.value,
      ]),
    },
  };
});
const tokenApproval = useTokenApproval(
  addressIn,
  props.trading.tokenInAmountInput,
  tokens
);
const gnosisRelayerApproval = useRelayerApproval(
  Relayer.GNOSIS,
  props.trading.isGnosisTrade
);
const pools = computed<(Pool | SubgraphPoolBase)[]>(
  // @ts-ignore - Fix types incompatibility error
  () => {
    return props.trading.sor.pools.value;
  }
);
const wrapType = computed(() =>
  getWrapAction(
    props.trading.tokenIn.value.address,
    props.trading.tokenOut.value.address
  )
);
const isStETHTrade = computed(
  () =>
    isStETH(addressIn.value, props.trading.tokenOut.value.address) &&
    wrapType.value === WrapType.NonWrap
);
const lidoRelayerApproval = useRelayerApproval(Relayer.LIDO, isStETHTrade);
const requiresTokenApproval = computed(() => {
  if (props.trading.isWrap.value && !props.trading.isEthTrade.value) {
    return approvalRequired(
      props.trading.tokenIn.value.address,
      props.trading.tokenInAmountInput.value,
      props.trading.tokenOut.value.address
    );
  } else if (props.trading.requiresTokenApproval.value) {
    return !tokenApproval.isUnlockedV2.value;
  }
  return false;
});
const requiresGnosisRelayerApproval = computed(
  () =>
    props.trading.isGnosisTrade.value &&
    props.trading.requiresTokenApproval.value &&
    !gnosisRelayerApproval.isUnlocked.value
);
const requiresLidoRelayerApproval = computed(
  () =>
    props.trading.isBalancerTrade.value && !lidoRelayerApproval.isUnlocked.value
);
const showTokenApprovalStep = computed(
  () =>
    requiresTokenApproval.value ||
    tokenApproval.approved.value ||
    tokenApproval.approving.value
);
const showGnosisRelayerApprovalStep = computed(
  () =>
    requiresGnosisRelayerApproval.value ||
    gnosisRelayerApproval.init.value ||
    gnosisRelayerApproval.approved.value ||
    gnosisRelayerApproval.approving.value
);
const showLidoRelayerApprovalStep = computed(
  () =>
    requiresLidoRelayerApproval.value ||
    lidoRelayerApproval.init.value ||
    lidoRelayerApproval.approved.value ||
    lidoRelayerApproval.approving.value
);
const totalRequiredTransactions = computed(() => {
  let txCount = 1; // trade
  if (showTokenApprovalStep.value) {
    txCount++;
  }
  if (showGnosisRelayerApprovalStep.value) {
    txCount++;
  } else if (showLidoRelayerApprovalStep.value) {
    txCount++;
  }
  return txCount;
});
const activeTransactionType = computed<
  'gnosisRelayerApproval' | 'lidoRelayerApproval' | 'tokenApproval' | 'trade'
>(() => {
  if (requiresGnosisRelayerApproval.value) {
    return 'gnosisRelayerApproval';
  }
  if (requiresLidoRelayerApproval.value) {
    return 'lidoRelayerApproval';
  }
  if (requiresTokenApproval.value) {
    return 'tokenApproval';
  }
  return 'trade';
});
const requiresApproval = computed(
  () =>
    requiresGnosisRelayerApproval.value ||
    requiresLidoRelayerApproval.value ||
    requiresTokenApproval.value
);
const showPriceUpdateError = computed(
  () =>
    !requiresApproval.value && priceUpdated.value && !priceUpdateAccepted.value
);
const tradeDisabled = computed(
  () => requiresApproval.value || showPriceUpdateError.value
);

// METHODS
function trade() {
  emit('trade');
}
function onClose() {
  emit('close');
}
function cofirmPriceUpdate() {
  priceUpdated.value = false;
  priceUpdateAccepted.value = true;
  lastQuote.value = props.trading.getQuote();
}
function handlePriceUpdate() {
  if (lastQuote.value != null) {
    const newQuote = props.trading.getQuote();
    /**
     * The bignumber returned via the quotes for some reason throw underflow
     * errors when attempting to use the gt function with the threshold value.
     * For that reason, the price difference has to be cast to our bignumber type.
     */
    if (props.trading.exactIn.value) {
      const priceDiff = lastQuote.value.minimumOutAmount
        .sub(newQuote.minimumOutAmount)
        .abs()
        .div(lastQuote.value.minimumOutAmount);
      priceUpdated.value = bnum(priceDiff.toString()).gt(
        PRICE_UPDATE_THRESHOLD
      );
    } else {
      const priceDiff = lastQuote.value.maximumInAmount
        .sub(newQuote.maximumInAmount)
        .abs()
        .div(lastQuote.value.maximumInAmount);
      priceUpdated.value = bnum(priceDiff.toString()).gt(
        PRICE_UPDATE_THRESHOLD
      );
    }
    if (priceUpdated.value) {
      priceUpdateAccepted.value = false;
    }
  }
}
async function approveToken(): Promise<void> {
  if (props.trading.isWrap.value && !props.trading.isEthTrade.value) {
    // If we're wrapping a token other than native ETH
    // we need to approve the underlying on the wrapper
    await tokenApproval.approveSpender(props.trading.tokenOut.value.address);
  } else {
    await tokenApproval.approveV2();
  }
}
// WATCHERS
watch(blockNumber, () => {
  handlePriceUpdate();
});

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: "",
    onClose: onClose,
    class: "confirm-swap"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(CloseIcon, {
              onClick: onClose,
              class: "cursor-pointer"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_BalAsset, {
              address: props.trading.tokenIn.value.address,
              class: "shadow"
            }, null, 8, ["address"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.trading.tokenIn.value.symbol), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(props.trading.tokenInAmountInput.value) + " ", 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(tokenInFiatValue)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(ArrowDownSwap)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_BalAsset, {
              address: props.trading.tokenOut.value.address,
              class: "shadow"
            }, null, 8, ["address"]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(__props.trading.tokenOut.value.symbol), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(props.trading.tokenOutAmountInput.value) + " ", 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(tokenOutFiatValue)), 1)
          ])
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(TradePreviewModalGP, {
            trading: __props.trading,
            onTrade: trade,
            onClose: _ctx.handlePreviewModalClose
          }, null, 8, ["trading", "onClose"])
        ]),
        (priceUpdated.value.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmPriceUpdate && _ctx.confirmPriceUpdate(...args))),
                class: "confirm-update-btn dark-back"
              }, " Accept ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_unref(requiresGnosisRelayerApproval))
          ? (_openBlock(), _createBlock(_component_BalBtn, {
              key: 0,
              block: "",
              loading: 
            _unref(gnosisRelayerApproval).init.value ||
            _unref(gnosisRelayerApproval).approving.value
          ,
              loadingLabel: `${_ctx.$t('approvingGnosisRelayer')}...`,
              onClick: _withModifiers(_unref(gnosisRelayerApproval).approve, ["prevent"]),
              color: "gradient"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('approveGnosisRelayer')), 1)
              ]),
              _: 1
            }, 8, ["loading", "loadingLabel", "onClick"]))
          : (_unref(requiresLidoRelayerApproval))
            ? (_openBlock(), _createBlock(_component_BalBtn, {
                key: 1,
                block: "",
                loading: 
            _unref(lidoRelayerApproval).init.value || _unref(lidoRelayerApproval).approving.value
          ,
                loadingLabel: `${_ctx.$t('approvingLidoRelayer')}...`,
                onClick: _withModifiers(_unref(lidoRelayerApproval).approve, ["prevent"]),
                color: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('approveLidoRelayer')), 1)
                ]),
                _: 1
              }, 8, ["loading", "loadingLabel", "onClick"]))
            : (_unref(requiresTokenApproval))
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 2,
                  loading: _unref(tokenApproval).approving.value,
                  loadingLabel: `${_ctx.$t('approving')} ${__props.trading.tokenIn.value.symbol}...`,
                  block: "",
                  onClick: _withModifiers(approveToken, ["prevent"]),
                  color: "gradient"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`${_ctx.$t('approve')} ${__props.trading.tokenIn.value.symbol}`), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "loadingLabel", "onClick"]))
              : (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 3,
                  block: "",
                  loading: __props.trading.isConfirming.value,
                  loadingLabel: _ctx.$t('confirming'),
                  disabled: _unref(tradeDisabled),
                  class: "relative",
                  onClick: _withModifiers(trade, ["prevent"]),
                  color: "gradient"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(labels).confirmTrade), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "loadingLabel", "disabled", "onClick"])),
        (__props.trading.submissionError.value != null)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 4,
              class: "mt-4 p-3",
              type: "error",
              size: "md",
              title: _ctx.$t('tradeSubmissionError.title'),
              description: __props.trading.submissionError.value,
              block: "",
              actionLabel: _ctx.$t('tradeSubmissionError.actionLabel'),
              onActionClick: __props.trading.resetSubmissionError
            }, null, 8, ["title", "description", "actionLabel", "onActionClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})